<ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: menuItem, level: 1}"></ng-container>

<ng-template #menuItemTemplate let-item let-subClass="subClass" let-level="level">
  <div class="menu-draggable-item-container"
       [ngClass]="navigationInteractionsService.checkLayer(item)"
       [class.last-layer]="level === 3"
       [ngClass]="subClass">
    <div class="menu-draggable-item"
         [class.editMode]="((editItem?.temp_id && editItem?.temp_id === item?.temp_id) || (editItem?.id && editItem?.id === item?.id))"
         (click)="setEdit(item)">
      <ng-container *ngIf="!editItem || !((editItem?.temp_id && editItem?.temp_id === item?.temp_id) || (editItem?.id && editItem?.id === item?.id)); else editView">
        <div class="menu-draggable-item-title-block">
          <i class="db-icon db-icon-ds-drag handle"></i>
          <span class="menu-draggable-item-title" [innerHTML]="item?.title"></span>
        </div>
        <div class="menu-draggable-item-category-block">
          <span class="menu-draggable-item-category mr8">{{types[item?.object_type]}}</span>
          <i class="db-icon db-icon db-icon-ds-arrow-small"></i>
        </div>
      </ng-container>
      <ng-template #editView>
        <db-edit-ecommerce-navigation-item
          (saveItem)="onSaveItem($event)"
          (deleteItem)="onDeleteItem($event)"
          [menuItem]="item"
          [types]="types"></db-edit-ecommerce-navigation-item>
      </ng-template>
    </div>

    <div class="menu-draggable-item-sub"
         [class.cover-element]="!item?.children.length"
         [dragula]="'navigation'"
         [class.has-child]="!!item?.children.length"
         [(dragulaModel)]="item.children"
         *ngIf="item?.children">
      <ng-container *ngFor="let child of item?.children">
        <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: child, subClass:'sub-item', level: level + 1 }" ></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

